//
import { createAsyncThunk } from '@reduxjs/toolkit'
import { lessonManagementAPI } from 'src/api/lesson-management'
import { IFinalTestRequest } from 'src/interfaces/final-test'
import { ILessonCreateForm } from 'src/interfaces/lesson'

export const deleteLessonAction = createAsyncThunk(
  'lesson/deleteLesson',
  async (id: number, { fulfillWithValue }) => {
    try {
      const res = await lessonManagementAPI.deleteLesson(id)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getLessonById = createAsyncThunk(
  'lesson/getLessonById',
  async (payload: { id: number }, { fulfillWithValue }) => {
    try {
      const res = await lessonManagementAPI.getLessonById(payload.id)
      return res.data
    } catch (error) {
      throw error
    }
  }
)

export const createLesson = createAsyncThunk(
  'lesson/createLesson',
  async (
    payload: Partial<ILessonCreateForm> & {
      mediaIds?: number[]
    }
  ) => {
    try {
      const res = await lessonManagementAPI.createLesson(payload)
      return res.data
    } catch (error) {
      throw error
    }
  }
)

export const createFinalTestSectionAction = createAsyncThunk(
  'lesson/createFinalTestSection',
  async (payload: Partial<IFinalTestRequest>) => {
    try {
      const res = await lessonManagementAPI.createFinalTestSection(payload)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const updateFinalTestSectionAction = createAsyncThunk(
  'lesson/updateFinalTestSection',
  async (payload: { id: number; data: Partial<IFinalTestRequest> }) => {
    try {
      const res = await lessonManagementAPI.updateFinalTestSection(
        payload.id,
        payload.data
      )
      return res
    } catch (error) {
      throw error
    }
  }
)

export const editLesson = createAsyncThunk(
  'lesson/editLesson',
  async (
    payload: Partial<ILessonCreateForm> & {
      mediaIds?: number[]
      id: string | number
    }
  ) => {
    try {
      const res = await lessonManagementAPI.editLesson(payload)
      return res.data
    } catch (error) {
      throw error
    }
  }
)

export const uploadLessonMedia = createAsyncThunk(
  'lesson/uploadLessonMedia',
  async (
    payload: Partial<ILessonCreateForm> & {
      mediaIds?: number[]
    }
  ) => {
    try {
      const res = await lessonManagementAPI.createLesson(payload)
      return res.data
    } catch (error) {
      throw error
    }
  }
)
